import { useDialog } from "@/hooks/useDialog";
import { useVariation } from "@hackler/react-sdk";
import { customEvent } from "goi_common";
import { useRouter } from "next/router";
import React, { useCallback, useEffect, useState } from "react";

export default function useRouterChangeLoad() {
  const router = useRouter();
  const { onOpen, onClose } = useDialog();
  const [confirmed, setConfirmed] = useState(false);
  const [toUrl, setToUrl] = useState("");
  const variation = useVariation(42);
  // const isLoggedIn = useRecoilValue(isLoggedInState);

  const handleBeforeunload = (e: any) => {
    if (e.target.activeElement) {
      if (e.target.activeElement.textContent === "받은 견적 더 자세히 알아보기") return;
    }

    e.preventDefault();
    e.returnValue = "";

    return "";
  };

  // 라우터 이동 방지
  const routeChangeStart = useCallback(
    (url: string) => {
      if (url.split("?")[0] === "/match/request-complete/") return;
      if (url === "/match/recommendations/") return;
      if (url.includes("/match/recommendation/")) return;
      if (url.split("?")[0] === "/login/") return;
      if (url === "/consult/list/?currentTab=match") return;

      if (router.asPath.split("?")[0] !== url.split("?")[0] && !confirmed) {
        if (url.includes("facility-recommendation") || url.includes("parlor-recommendation")) {
          return;
        }
        if (url.includes("match-compare")) {
          return;
        }
        // 뒤로가기 시 page url 비교 후 match request url로 변경
        if (router.asPath !== window.location.pathname) {
          window.history.pushState("", "", router.asPath);
        }
        setToUrl(url);
        customEvent({
          newGtm: {
            path: "match_request",
            trigger_and_target: "open_before_leave_modal",
          },
        });
        if (variation === "A") {
          // 확인 -> 페이지 이동
          onOpen({
            type: 1,
            header: "거의 다 왔어요",
            footerProps: [
              {
                text: "그만두기",
                onClick: () => {
                  customEvent({
                    newGtm: {
                      path: "match_request",
                      trigger_and_target: "before_leave_modal_quit-go_back",
                    },
                  });
                  setConfirmed(true);
                },
              },
              {
                text: "계속하기",
                onClick: () => {
                  customEvent({
                    newGtm: {
                      path: "match_request",
                      trigger_and_target: "before_leave_modal-continue",
                    },
                  });
                  onClose();
                },
              },
            ],
            children: (
              <>
                견적을 제출한 고객님들은
                <br />
                장례 비용을 평균 246만원 아끼고 있어요
              </>
            ),
          });
        } else {
          onOpen({
            type: 1,
            header: "거의 다 왔어요",
            footerProps: [
              {
                text: "계속하기",
                onClick: () => {
                  customEvent({
                    newGtm: {
                      path: "match_request",
                      trigger_and_target: "before_leave_modal-continue",
                    },
                  });
                  onClose();
                },
              },
              {
                text: "그만두기",
                onClick: () => {
                  customEvent({
                    newGtm: {
                      path: "match_request",
                      trigger_and_target: "before_leave_modal_quit-go_back",
                    },
                  });
                  setConfirmed(true);
                },
              },
            ],
            children: (
              <>
                견적을 제출한 고객님들은
                <br />
                장례 비용을 평균 246만원 아끼고 있어요
              </>
            ),
          });
        }

        //강제 router error 발생시켜 페이지 이동 방지
        router.events.emit("routeChangeError");
        throw "Abort route change. Please ignore this error.";
      }
    },
    [confirmed, router.asPath, router.events],
  );

  useEffect(() => {
    //window 새로고침시 이벤트핸들러
    window.addEventListener("beforeunload", handleBeforeunload);

    // router 변화시 이벤트 헨들러
    router.events.on("routeChangeStart", routeChangeStart);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeunload);
      router.events.off("routeChangeStart", routeChangeStart);
    };
  }, [routeChangeStart, router.events]);

  useEffect(() => {
    // 수락시 이동
    if (confirmed) {
      onClose();

      router.replace(toUrl);
    }
  }, [confirmed]);
}
